import React, { FC } from 'react';
import styled from 'styled-components';

import BodyText from '@ui/atoms/BodyText';
import Header from '@ui/atoms/Header';
import StyledLink from '@ui/atoms/StyledLink';

import theme from '@theme/FolxTheme';

const AppointmentScheduledContainer = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	margin: 0 ${theme.spacing.sm} ${theme.spacing.md};
	gap: ${theme.spacing.sm};
`;

const AppointmentScheduled: FC<{}> = ({}) => {
	return (
		<AppointmentScheduledContainer>
			<Header level="4">Appointment scheduled!</Header>
			<BodyText>Congratulations! You have successfully scheduled your appointment!</BodyText>
			<StyledLink variant="underline" to="/app/member/appointments">
				Back to Appointments
			</StyledLink>
		</AppointmentScheduledContainer>
	);
};

export default AppointmentScheduled;
